/**
 * カレンダー関連のメソッド群
 */

/** カレンダーヘッダー日付 リスト */
export const initDateForPage = (page) => {
  const date = new Date();
  if (page !== 0) {
    date.setDate(date.getDate() + page * 7);
  }
  return date;
};
